import { useConversionStore } from '@/pages/ISWAN_APP/hooks/useConversionStore/useConversionStore';
import { useResponsingStore } from '@/pages/ISWAN_APP/hooks/useResponsingStore/useResponsingStore';
import s from '@/pages/ISWAN_APP/layout/NavBar/NavBar.less';
import AISelectMenu from '@/pages/ISWAN_CHAT/components/AISelectMenu/AISelectMenu';
import ChatHistory from '@/pages/ISWAN_CHAT/components/ChatHistory/ChatHistory';
import NewChatButton from '@/pages/ISWAN_CHAT/components/NewChatButton/NewChatButton';
import { useChatHistory } from '@/pages/ISWAN_CHAT/hooks/useChatHistory/useChatHistory';
import { AIType } from '@/pages/ISWAN_CHAT/interface';
import { history, useModel } from '@@/exports';
import { Drawer, message } from 'antd';
import React, { useEffect, useImperativeHandle, useState } from 'react';

export interface NavDrawerRef {
  openDrawer: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const NavDrawer = React.forwardRef<NavDrawerRef>((_, ref) => {
  const { storeConversationId, setStoreConversationId } = useConversionStore();
  const { responsing } = useResponsingStore();
  const [aiType, setAiType] = useModel('ISWAN_CHAT.aiType');
  const { chatHistory, loadFromRemote, deleteById, renameById } = useChatHistory();
  const [drawerShow, setDrawerShow] = useState(false);

  useImperativeHandle(ref, () => {
    return {
      openDrawer: () => {
        setDrawerShow(true);
      },
    };
  });

  useEffect(() => {
    if (drawerShow) {
      loadFromRemote();
    }
  }, [drawerShow]);

  function handleDelete(id: string) {
    if (storeConversationId === id) {
      setStoreConversationId();
    }
    return deleteById(id);
  }

  function handleChangeActiveCId(cid: string) {
    setDrawerShow(false);

    if (responsing) {
      message.info('请等待当前 AI 回复完毕哦');
      return;
    }

    setStoreConversationId(cid);
  }

  function handleSelectAiType(key: AIType) {
    setDrawerShow(false);

    if (responsing) {
      message.info('请等待当前 AI 回复完毕哦');
      return;
    }

    setStoreConversationId();
    setAiType(key);
    history.push(`/app/aiChat`);
  }

  function handleNewConversion() {
    setDrawerShow(false);

    if (responsing) {
      message.info('请等待当前 AI 回复完毕哦');
      return;
    }

    setStoreConversationId();
  }

  // function handleBackHome() {
  //   history.push(`/app/workspace`);
  //   setDrawerShow(false);
  // }

  return (
    <>
      <Drawer
        open={drawerShow}
        onClose={() => setDrawerShow(false)}
        placement="left"
        width={'70%'}
        styles={{ header: { display: 'none' }, body: { padding: 0 } }}
      >
        <div className={s.drawerBody}>
          {/*<div className={s.title} onClick={handleBackHome}>*/}
          {/*  <div className={s.title_left}>*/}
          {/*    <div className={s.icon}>*/}
          {/*      <FillImage src={cloud7f_logo} />*/}
          {/*    </div>*/}
          {/*    <div>Edatlink AI</div>*/}
          {/*  </div>*/}
          {/*  <div className={s.title_right}>*/}
          {/*    <HomeOutlined />*/}
          {/*  </div>*/}
          {/*</div>*/}

          <div className={s.newBtn}>
            <NewChatButton onClick={handleNewConversion} />
          </div>

          <div className={s.aiSelect}>
            <AISelectMenu onClick={handleSelectAiType} />
          </div>

          <div className={s.divider} />

          {aiType !== null && aiType !== 'Robot' && (
            <>
              <div className={s.historyTitle}>
                {/*<div className={s.historyTitleIcon}>*/}
                {/*  <FillImage src={icon_history} />*/}
                {/*</div>*/}
                <div>最近对话</div>
              </div>

              <div className={s.history}>
                <ChatHistory
                  chatHistory={chatHistory}
                  activeHistory={storeConversationId}
                  onActiveChange={handleChangeActiveCId}
                  onDelete={handleDelete}
                  onRename={renameById}
                />
              </div>
            </>
          )}
        </div>
      </Drawer>
    </>
  );
});

export default NavDrawer;
